<template>
<div class="profile_container">
    <nav class="profile_nav" :class="{ 'menu-open': isMenuOpen }">
        <ul>
            <li class="profile_nav__list" :class="{ 'open_submenu': visibleSubmenuIndex === index}" v-for="(item, index) in menuItems" :key="index">
                <span v-if="hasAccess(item.roles)" @click="toggleSubMenu(index, item)">{{ item.title }}</span>
                <ul class="profile_sub__list" :class="{ 'open_submenu': visibleSubmenuIndex === index}">
                    <li class="list__submenu" v-for="(subitem, subindex) in item.submenu" :key="subindex" :class="{ 'selected': currentComponent.name === subitem.component }">
                        <span @click="changeComponentVisibility(index, subitem)">{{ subitem.title }}</span>
                    </li>
                </ul>
            </li>
        </ul>
        <span @click="toggleMenu" class="btn-reset toggle-menu-button">
            {{ isMenuOpen ? "&lt;" : "&gt;" }}
        </span>
    </nav>
    <section class="profile_main">
        <component :is="currentComponent" :key="currentComponentKey" :callbackFunction="callbackFunction" :userData="userData" :compData="dataForComponents"></component>
    </section>
</div>
</template>

<script>
import $ from 'jquery';
import menuData from "@/data/profile_menu.json";
import NotFound from "@/components/NotFound.vue";

export default {
    components: {
        NotFound,
    },
    data() {
        return {
            userData: [],
            isMenuOpen: false,
            menuItems: menuData,
            visibleSubmenuIndex: null,
            visibleSubmenuItemIndex: null,
            currentComponent: NotFound,
            currentComponentKey: 0,
            dataForComponents: [],
        };
    },
    methods: {
        callbackFunction(item) {
            console.log('Callback function in NewProfilePage.vue is called with data:', item);
            this.changeComponent(item.component)
            this.dataForComponents = item.data
        },
        async changeComponent(component) {
            try {
                const dynamicImport = await import(`@/components/${component}.vue`);
                const newComponent = dynamicImport.default;

                if (newComponent) {
                    this.currentComponent = newComponent;
                    this.currentComponentKey += 1;
                } else {
                    console.error(`Компонент не импортирован: ${component}`);
                    this.currentComponent = NotFound;
                    this.currentComponentKey += 1;
                    this.$parent.$parent.setSubHeaderTitle('Страница не найдена');
                }
                
            } catch (error) {
                console.error(`Компонент не импортирован: ${component}`);
                this.currentComponent = NotFound;
                this.currentComponentKey += 1;
                this.$parent.$parent.setSubHeaderTitle('Страница не найдена');
            }
        },
        hasAccess(roles) {
            const userRole = this.getCookie("role");
            return roles.some(role => userRole === role);
        },
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        toggleSubMenu(index, item) {
            this.visibleSubmenuIndex = this.visibleSubmenuIndex === index ? null : index;

            if (this.visibleSubmenuIndex != null) {
                if (item.component) {
                    this.changeComponentVisibility(index, item, true);
                }
            }
        },
        importComponent(item) {
            if (item.component != 'OrderEditingPage') {
                let userAccess = this.hasAccess(item.roles)
                if (!userAccess) return console.error(`Отсутствует доступ к ${item.component}`)
            }
            this.changeComponent(item.component)
        },
        async changeComponentVisibility(index, item, check) {
            if ((this.visibleSubmenuIndex === index) || (check == true)) {
                this.importComponent(item)
                this.$parent.$parent.setSubHeaderTitle(item.title);
            }
        },
    },
    mounted() {
        let vm = this;

        const userRole = this.getCookie("role");
        if (userRole === '') {
            this.$router.push({ name: 'authorization'} );
        }

        $.ajax({
            type: "GET",
            xhrFields: { withCredentials: true },
            url: global.BACKEND_URL + `/account`,
            success: function (data) {
                vm.userData.name = data["name"]
                vm.userData.patronymic = data["patronymic"]
                vm.userData.phone = data["phone"]
                vm.userData.email = data["email"]
                vm.userData.default_region = data["region"]
                vm.userData.organisation = data["organisation"]

                vm.importComponent(vm.menuItems[2].submenu[0]); // TODO this is for debug, opens orders by default
            },
            error: function () { console.log("Not success :(") },
            dataType: "json",
            contentType: "application/json"
        })

    }
};
</script>

<style scoped src="@/assets/css/profile_page.css"></style>
